import { render, staticRenderFns } from "./AdminPlugin.vue?vue&type=template&id=34d10b66&scoped=true&"
import script from "./AdminPlugin.vue?vue&type=script&lang=js&"
export * from "./AdminPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d10b66",
  null
  
)

export default component.exports